console.log(1);
(function ($) {
    $(document).ready(function () {





    });
})(jQuery);



document.addEventListener('DOMContentLoaded', function () {

    const burgerMenu = document.getElementById('burger-menu');
    const mobileMenuOverlay = document.getElementById('mobile-menu-overlay');
    const mobileMenu = document.querySelector('.mobile-menu');

    if (!burgerMenu || !mobileMenuOverlay) {
        return; // Exit if elements not found
    }

    // Toggle mobile menu
    function toggleMobileMenu() {
        const isActive = mobileMenuOverlay.classList.contains('active');

        if (isActive) {
            mobileMenuOverlay.classList.remove('active');
            document.body.style.overflow = '';
        } else {
            mobileMenuOverlay.classList.add('active');
            document.body.style.overflow = 'hidden';
        }
    }

    // Open menu when burger clicked
    burgerMenu.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        toggleMobileMenu();
    });

    // Close menu when clicking overlay (outside menu)
    mobileMenuOverlay.addEventListener('click', function (e) {
        if (e.target === mobileMenuOverlay) {
            toggleMobileMenu();
        }
    });

    // Close menu when clicking a link
    const mobileNavLinks = document.querySelectorAll('.mobile-nav-link');
    mobileNavLinks.forEach(function (link) {
        link.addEventListener('click', function () {
            toggleMobileMenu();
        });
    });

    // Close menu on escape key
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && mobileMenuOverlay.classList.contains('active')) {
            toggleMobileMenu();
        }
    });

    // Close menu on resize to desktop size
    window.addEventListener('resize', function () {
        if (window.innerWidth > 992 && mobileMenuOverlay.classList.contains('active')) {
            toggleMobileMenu();
        }
    });



    // Toggle to show and hide dropdown menu
    const dropdown = document.querySelectorAll(".header-nav");

    dropdown.forEach((item) => {
        const dropdownToggle = item.querySelector(".nav-link-category");
        dropdownToggle.addEventListener("mouseenter", () => {
            document.querySelector('.header')

        })
    })


    dropdown.forEach((item) => {
        const dropdownToggle = item.querySelector(".nav-link-category");

        dropdownToggle.addEventListener("click", () => {
            const dropdownShow = document.querySelector(".dropdown-show");
            toggleDropdownItem(item);

            // Remove 'dropdown-show' class from other dropdown
            if (dropdownShow && dropdownShow != item) {
                toggleDropdownItem(dropdownShow);
            }
        });
    });

    // Function to display the dropdown menu
    const toggleDropdownItem = (item) => {
        const dropdownContent = item.querySelector(".dropdown-content");

        // Remove other dropdown that have 'dropdown-show' class
        if (item.classList.contains("dropdown-show")) {
            dropdownContent.removeAttribute("style");
            item.classList.remove("dropdown-show");
        } else {
            // Added max-height on active 'dropdown-show' class
            dropdownContent.style.height = dropdownContent.scrollHeight + "px";
            item.classList.add("dropdown-show");
        }
    };

    // Fixed dropdown menu on window resizing
    window.addEventListener("resize", () => {
        if (window.innerWidth > 992) {
            document.querySelectorAll(".dropdown-content").forEach((item) => {
                item.removeAttribute("style");
            });
            dropdown.forEach((item) => {
                item.classList.remove("dropdown-show");
            });
        }
    });




    const heroSwiper = new Swiper('.hero-swiper', {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        speed: 1200,
        autoplay: {
            delay: 6500,
            disableOnInteraction: false,
        },
        on: {
            init: function (slider) {
                const totalEl = document.querySelector('.hero-pagination .pagination-total');
                const currentEl = document.querySelector('.hero-pagination .pagination-current');
                const lineInner = document.querySelector('.hero-pagination .pagination-line-inner');

                const totalSlides = this.slides.length;
                totalEl.textContent = `/ ${String(totalSlides).padStart(2, '0')}`;
                currentEl.textContent = String(this.realIndex + 1).padStart(2, '0');

                const progress = ((this.realIndex) / totalSlides) * 100;
                lineInner.style.left = `${progress}%`;
            },
            slideChange: function () {
                const totalEl = document.querySelector('.hero-pagination .pagination-total');
                const currentEl = document.querySelector('.hero-pagination .pagination-current');
                const lineInner = document.querySelector('.hero-pagination .pagination-line-inner');

                const totalSlides = this.slides.length;
                const currentIndex = this.realIndex + 1;

                currentEl.textContent = String(currentIndex).padStart(2, '0');

                const progress = ((this.realIndex) / totalSlides) * 100;
                lineInner.style.left = `${progress}%`;

                   setTimeout(() => {
          AOS.refreshHard();
        }, 100); // невелика затримка для стабільності
            }
        }
    });

    document.querySelectorAll('.sale_section').forEach(section => {
        const swiperEl = section.querySelector('.sale_swiper');
        const nextBtn = section.querySelector('.swiper-button-next');
        const prevBtn = section.querySelector('.swiper-button-prev');

        if (swiperEl) {
            new Swiper(swiperEl, {
                slidesPerView: 1.5,
                spaceBetween: 20,
                loop: true,
                speed: 1200,

                breakpoints: {
                    768: {
                        slidesPerView: 3,
                    },
                    992: {
                        slidesPerView: 4,
                    }
                },

                navigation: {
                    nextEl: nextBtn,
                    prevEl: prevBtn,
                },
                scrollbar: {
                    el: section.querySelector('.swiper-scrollbar'),
                    draggable: true,
                },
            });
        }
    });
    document.querySelectorAll('.collection_section').forEach(section => {
        const swiperEl = section.querySelector('.collection_swiper');
        const nextBtn = section.querySelector('.swiper-button-next');
        const prevBtn = section.querySelector('.swiper-button-prev');

        if (swiperEl) {
            new Swiper(swiperEl, {
                slidesPerView: 1,
                spaceBetween: 20,
                loop: true,
                speed: 1200,
                //  grid: {
                //     rows: 2,
                // },
                breakpoints: {
                    768: {
                        slidesPerView: "auto",
                         grid: {
                    rows: 1,
                },
                    }
                },

                navigation: {
                    nextEl: nextBtn,
                    prevEl: prevBtn,
                },
                scrollbar: {
                    el: section.querySelector('.swiper-scrollbar'),
                    draggable: true,
                },
            });
        }
    });

    document.querySelectorAll('.reviews_section').forEach(section => {
        const swiperEl = section.querySelector('.reviews_swiper');
        const nextBtn = section.querySelector('.swiper-button-next');
        const prevBtn = section.querySelector('.swiper-button-prev');

        const slidesCount = swiperEl.querySelectorAll('.swiper-slide').length;
        console.log(slidesCount);


        if (swiperEl) {
            new Swiper(swiperEl, {
                slidesPerView: 1,
                spaceBetween: 20,
                loop: true,
                speed: 1200,
                watchSlidesProgress: true,
                breakpoints: {

                    992: {
                        slidesPerView: 1.9,
                        spaceBetween: 100,
                    },
                    1000: {
                        slidesPerView: 1.9,
                        spaceBetween: 100,
                        centeredSlides: true,
initialSlide: 22,

                    }
                },

                navigation: {
                    nextEl: nextBtn,
                    prevEl: prevBtn,
                },

            });
        }
    });


if(document.querySelector('.instagram_swiper')){
const instagram_swiper = new Swiper('.instagram_swiper', {

    slidesPerView: 1.5,
    spaceBetween: 30,
    breakpoints: {
        768: {
            slidesPerView: 4,
    spaceBetween: 20,
        }
    }

})}

});


AOS.init({
    // once: true,
    duration: 1000,
});